<!-- Fixer Header: bewusst AUSSERHALB des dx-drawer, damit position:fixed am
     Viewport verankert bleibt (ein transform am Drawer würde es sonst aushebeln). -->
<new-app-navigation-menu></new-app-navigation-menu>

<!-- [ngClass]="{ 'primary-menu-hidden': !(context | async).menuItems.primary.length || (isMobile$ | async), 'mobile-screen': isMobile$ | async }" -->
<dx-drawer
  [openedStateMode]="selectedOpenMode"
  [position]="selectedPosition"
  [revealMode]="selectedRevealMode"
  [(opened)]="isDrawerOpen"
  [height]="400"
  template="template"
  [closeOnOutsideClick]="false"
>
  <div *dxTemplate="let data of 'template'">
    <!-- Auf dem Phone wird die Seitennavigation nicht gerendert (dort nicht bedienbar). -->
    <app-main-navigation
      *ngIf="!(isPhone$ | async)"
      (drawerOpen)="toggleNavigation($event)"
    ></app-main-navigation>
  </div>
  <!-- Dokument-Scroll: Der frühere DevExtreme dx-scroll-view wurde entfernt;
       gescrollt wird jetzt das Dokument. Der Wrapper trägt nur das Sticky-Footer-Layout. -->
  <div class="app-shell-scroll">

    <main class="content" id="main-content" [ngClass]="layout.contentClass">
      <ng-content></ng-content>
    </main>

    <new-app-footer *ngIf="layout.showFooter"></new-app-footer>

  </div>
</dx-drawer>
<!-- KS, 20260707, keine Footer Mobile Navigation 
<app-mobile-navigation class="mobile-navigation" *ngIf="isMobile$ | async"></app-mobile-navigation>
-->
<app-spinner></app-spinner>
